import { CodecUtils } from 'common/utils/codec-utils';

export enum SubscriptionActivityStatus {
  None = 'None',
  Active = 'Active',
  Trial = 'Trial',
  Canceled = 'Canceled',
  Mocked = 'Mocked',
  NonRenewing = 'NonRenewing',
}

export const SubscriptionActivityStatusC =
  CodecUtils.createEnumCodec<SubscriptionActivityStatus>(SubscriptionActivityStatus, 'SubscriptionActivityStatus');
